const booleanFormatter = (key, value, model, record, translate) => {
    if (value === true) return "Да"
    if (value === false) return "Нет" 
}

export default booleanFormatter;